<script>
import lazyLoadComponent from '@router/lazyload-component'
import productMixin from '@/src/mixins/product'
import Layout from '@layouts/main'

export default {
  page: {
    title: '數據分析',
    meta: [
      { name: 'description', container: 'Data Analytics' },
      {
        name: 'google-signin-scope',
        content: 'https://www.googleapis.com/auth/analytics.readonly',
      },
    ],
  },
  mixins: [productMixin],
  components: {
    Layout,
  },
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    filterMerchantProducts() {
      return this.filterProductInMixin(JSON.parse(JSON.stringify(this.merchantProducts)))
    }
  },
  data() {
    return {
      activeTab: '0',
      formattedJson: '',
      tabList: Object.freeze([
        {
          title: '收益',
          component: () => lazyLoadComponent(import('./TabIncome')),
        },
        {
          title: '銷售',
          component: () => lazyLoadComponent(import('./TabSell')),
        },
        {
          title: '優惠券',
          component: () => lazyLoadComponent(import('./TabCoupon')),
        },
        {
          title: '服務人員',
          component: () => lazyLoadComponent(import('./TabStaff')),
        },
      ]),
    }
  },
  watch: {
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.page">
      <el-tabs v-model="activeTab" stretch type="border-card" class="isStyleBase">
        <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`">
        </el-tab-pane>
      </el-tabs>
      <div :class="[(activeTab === '1' || activeTab === '0')? '' : $style.marginContent]">
        <component :is="tabList[activeTab].component" :merchant-products="filterMerchantProducts">
        </component>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

:global {
  .isPage {
    .el-tabs__content {
      padding-bottom: 40px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.marginContent {
  margin: 20px;
}
</style>
